import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// Every page names itself as the canonical URL on https://feis.link (so www
// and the staging host point at production), without the query string or a
// trailing slash. og:url follows it. Link-preview scrapers don't run
// JavaScript and read the fixed tags in public/index.html instead.
export const SITE_ORIGIN = "https://feis.link";

export const canonicalUrl = (pathname) => `${SITE_ORIGIN}${(pathname || "").replace(/\/+$/, "") || "/"}`;

const upsert = (selector, tag, attrs, attr, value) => {
  let el = document.head.querySelector(selector);
  if (!el) {
    el = document.createElement(tag);
    Object.entries(attrs).forEach(([k, v]) => el.setAttribute(k, v));
    document.head.appendChild(el);
  }
  el.setAttribute(attr, value);
};

const CanonicalLink = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    const url = canonicalUrl(pathname);
    upsert('link[rel="canonical"]', "link", { rel: "canonical" }, "href", url);
    upsert('meta[property="og:url"]', "meta", { property: "og:url" }, "content", url);
  }, [pathname]);
  return null;
};

export default CanonicalLink;
